import $axios from "../api/accessor";
import { $api } from "../api/api";

interface ProductType {
  product_id: number;
  quantity: number;
}

export interface CompleteOrderBody {
  full_name: string;
  address: string | null;
  number_prefix: string;
  number: string;
  filial_id: number | null;
  products: ProductType[];
}

export const QuickOrdersService = {
  // bir klikle alınan sifarişləri götür
  async getAllQuickOrders() {
    let response = await $axios.get($api("quick_orders")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  // bir klikle alınan sifarişləri statusu dəyişdir
  async changeQuickOrderStatus(
    orderId: number,
    body: { status_name: string; note: string | null }
  ) {
    let response = await $axios
      .put($api(`quick_orders_id`, { orderId }), body)
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async createOrder(body: CompleteOrderBody) {
    try {
      let response = await $axios.post($api("create_quick_order"), body);
      return {
        data: response?.data ? response?.data : [],
        status: response?.status,
      };
    } catch (err: any) {
      return {
        data: err?.response?.data || err?.data || { message: "Xəta baş verdi" },
        status: err?.response?.status || err?.status || 500,
      };
    }
  },
};
